import img from '../assets/imgs/wehire.webp';
import EmploymentForm from './EmpForm';
import React, { useState } from 'react';
import '../assets/Career.css';

const Employment = () => {
    const [activeIndex, setActiveIndex] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const roles = [
        {
            title: 'Senior Sales Executive',
            location: 'Navale Icon vadgaon BK-Pune, India',
            type: 'Full Time',
            salary: 'Rs.10,000 - Rs.20,000',
            desc: 'senior Sales Executive responsibilities',
        },
        {
            title: 'CRM',
            location: 'Navale Icon vadgaon BK-Pune, India',
            type: 'Full Time',
            salary: 'Rs.10,000 - Rs.20,000',
            desc: 'CRM responsibilities',
        },
        {
            title: 'Senior Manager',
            location: 'Navale Icon vadgaon Bk-Pune, India',
            type: 'Full Time',
            salary: 'Rs.10,000 - Rs.20,000',
            desc: 'senior manager responsibilities',
        },
    ];

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <>
            <div className="employment-hero">
                <img src={img} loading="lazy" alt="Hiring" />
            </div>

            <div className="career-section">
                <h2 className="career-title">Our Open Roles</h2>
                <p className="career-contact">
                    OR CONTACT US WITH <a href="tel:+919511930099">+91 9511930099</a>
                </p>

                <div className="role-list">
                    {roles.map((role, index) => (
                        <div key={index} className="role-item">
                            <div className="role-header">
                                <div>
                                    <span className="role-label">OPEN ROLES</span>
                                    <h3 className="role-title">{role.title}</h3>
                                    <p className="role-meta">
                                        <span> {role.type} </span>  •
                                        <span> {role.salary} </span>  •
                                        <span> {role.location} </span>
                                    </p>
                                </div>
                                <div className="role-actions">
                                    <button
                                        className={`toggle-btn ${activeIndex === index ? 'active' : ''}`}
                                        onClick={() => toggleAccordion(index)}
                                    >
                                        ▼
                                    </button>
                                    <button className="apply-btn" onClick={openModal}>
                                        Submit Application ↗
                                    </button>
                                </div>
                            </div>

                            <div className={`role-details-wrapper ${activeIndex === index ? 'open' : ''}`}>
                                <div className="role-details">
                                    <p>
                                          {role.desc}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {isModalOpen && (
                    <div className="c-modal-overlay" onClick={closeModal}>
                        <div className="c-modal-content" onClick={(e) => e.stopPropagation()}>
                            <h3>Submit Application</h3>
                            <form className="c-modal-form">
                                <input type="text" placeholder="Your Name" required />
                                <input type="email" placeholder="Your Email" required />
                                <input type="phone" placeholder="Your Mobile Number" required />
                                <textarea placeholder="Interested Role" required></textarea>
                                <button type="submit">Submit</button>
                                <button type="button" onClick={closeModal} className="c-close-btn">
                                    Close
                                </button>
                            </form>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Employment;
